var custom = {
  init: function(){
  	custom.sliderHome();
    custom.searchExpand();
    custom.sliderCategory();
    custom.countDown();
    custom.mapMarket();
    custom.sidebarStickitCustom();
    custom.quantityNum();
    custom.sliderGallery();
    custom.hourReserv();
    custom.socialTeacher();
    custom.icoWhats();
    custom.sliderFoundation();
    custom.sliderTestimony();
    custom.animationBlock();
    custom.sliderCour();
    custom.videoIframe();
    custom.moreComment();
    custom.moreBlockAll();
    custom.countDownNavNoti();
  },
  animationBlock: function(){
    wow = new WOW({
      boxClass:     'wow',      // default
      animateClass: 'animated', // default
      offset:       0,          // default
      mobile:       true,       // default
      live:         true        // default
    });
    wow.init();
  },
  sliderHome: function(){
    /*if($(".slider-home").length){
      $('.slider-home').slick({
        arrows: false,
        dots: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 4000,
        fade: true,
        cssEase: 'linear'
      });
      $('.slider-home').on('beforeChange', function(event, slick, currentSlide, nextSlide){
        $('.slider-info').removeClass('aos-init').removeClass('aos-animate');
      });
      $('.slider-home').on('afterChange', function(event, slick, currentSlide, nextSlide){
        AOS.refresh();
      });
    }*/
    $('#hero-slider').on('init', function(e, slick) {
      var $firstAnimatingElements = $('div.hero-slide:first-child').find('[data-animation]');
      //console.log($firstAnimatingElements);
      doAnimations($firstAnimatingElements);    
    });
    $('#hero-slider').on('beforeChange', function(e, slick, currentSlide, nextSlide) {
      //console.log(nextSlide);
      var $animatingElements = $('.slider-home-slick div.slick-slide[data-slick-index="' + nextSlide + '"]').find('[data-animation]');
      //console.log($animatingElements);
      doAnimations($animatingElements);
    });
    $('#hero-slider').slick({
      autoplay: true,
      autoplaySpeed: 5000,
      dots: true,
      fade: true,
      arrows: false
    });
    function doAnimations(elements) {
      //console.log("Ejecutando");
      var animationEndEvents = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
      elements.each(function() {
        var $this = $(this);
        var $animationDelay = $this.data('delay');
        //console.log($animationDelay);
        var $animationType = 'animated ' + $this.data('animation');
        //console.log("Probando: "+$animationType);
        $this.css({
          'animation-delay': $animationDelay,
          '-webkit-animation-delay': $animationDelay
        });
        $this.addClass($animationType).one(animationEndEvents, function() {
          $this.removeClass($animationType);
        });
      });
    }
  },
  searchExpand: function(){
    function buttonUp(){
      var inputVal = $('.searchbox-input').val();
      inputVal = $.trim(inputVal).length;
      if( inputVal !== 0){
        $('.searchbox-icon').css('display','none');
      } else {
        $('.searchbox-input').val('');
        $('.searchbox-icon').css('display','block');
      }
    }
    var submitIcon = $('.searchbox-icon');
    var inputBox = $('.searchbox-input');
    var searchBox = $('.searchbox');
    var isOpen = false;
    submitIcon.click(function(){
      if(isOpen == false){
        searchBox.addClass('searchbox-open');
        inputBox.focus();
        isOpen = true;
      } else {
        searchBox.removeClass('searchbox-open');
        inputBox.focusout();
        isOpen = false;
      }
    });  
    submitIcon.mouseup(function(){
      return false;
    });
    searchBox.mouseup(function(){
      return false;
    });
    $(document).mouseup(function(){
      if(isOpen == true){
        $('.searchbox-icon').css('display','block');
        submitIcon.click();
      }
    });
  },
  countDown: function(){
    if($(".listTiempo").length){
      $('[data-countdown]').each(function () {
        var $this = $(this);
        var finalDate = $(this).data('countdown');
        var timeZone = $(this).data('timezone');        
        var newFinalDateTZ = finalDate;
        if (moment && timeZone) {
          console.log('timezone');
          var momentDate = moment.tz(finalDate, timeZone);
          newFinalDateTZ = momentDate.toDate();
        }        
        
        $this.countdown(newFinalDateTZ, function (event) {
            $this = $(this).html(event.strftime(''
            + '<div><span class="datos-tiempo">%D</span><em>Días</em></div><span>:</span>'
            + '<div><span class="datos-tiempo">%H</span><em>Horas</em></div><span>:</span>'
            + '<div><span class="datos-tiempo">%M</span><em>Min</em></div><span>:</span>'
            + '<div><span class="datos-tiempo">%S</span><em>Seg</em></div>'
            ));
        });
      });
    }
  },
  sliderCategory: function(){
    if($(".slider-category").length){
      $('.slider-category').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 3000,
        infinite: true,
        slidesToShow: 6,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          }
        ]
      });
    }
  },
  mapMarket: function(){
    if($(".map-canvas").length){
      $(".mapShow").click(function(e){
        e.preventDefault();
        $(".mapShow").remove();
        $(".map-canvas").addClass("map-show");
        var lat = $(".map-canvas").data("lat");
        var log = $(".map-canvas").data("lon");
        var direc = $(".map-canvas").data("direc");

        var map = new google.maps.Map($('.map-canvas')[0], {
            zoom: 16,
            center: new google.maps.LatLng(lat,log)
        });
        var marker = new google.maps.Marker({
            map: map,
            position: new google.maps.LatLng(lat,log)
        });
        var info = new SnazzyInfoWindow({
            marker: marker,
            closeOnMapClick: false,
            content: direc
        });
        info.open();
      });
    }
  },
  sidebarStickitCustom: function(){
    if($('.sidebar-stickit-custom').length){
      $('.sidebar-stickit-custom').stickit({
        screenMinWidth: 992,
        top: 60
      });
    }  
  },
  toggleUserCourse: function(e){
    if($(".info-text-autor").hasClass("toggle-active")){
      $(".toggle-click").removeClass("a-toggle");
      $(".info-text-autor").removeClass("toggle-active");
    }else{
      $(".toggle-click").addClass("a-toggle");
      $(".info-text-autor").addClass("toggle-active");
    }
  },
  quantityNum: function(){
    if($('.quantity').length){
      $('.add-l').click(function () {
        var dataMax = $(this).data('max');
        if ($(this).prev().val() < dataMax) {
          $(this).prev().val(+$(this).prev().val() + 1);
        }
      });
      $('.sub-l').click(function () {
        if ($(this).next().val() > 1) {
          if ($(this).next().val() > 1) $(this).next().val(+$(this).next().val() - 1);
        }
      });
    }
  },
  sliderCour: function(){
    if($('.block-slider-desktop').length){
      $(".block-slider-desktop").each(function(i) {
        var bloqueSlider = $(this).data("bloque");
        var bloqueAutoPlay = $(this).data("play");
        var arrowSlider = $(this).data("arrow");

        if ($("." + bloqueSlider).length) {
          sliderRender(bloqueSlider, bloqueAutoPlay, arrowSlider);
        }            

      });
      function sliderRender(bloque, modePlay, tArrow){
        var slider = tns({
          container: "." + bloque,
          items: 1,
          loop: true,
          swipeAngle: false,
          speed: 400,
          nav: false,
          autoplay: modePlay,
          autoplayHoverPause: true,
          autoplayTimeout: 3000,
          autoplayButtonOutput: false,
          controlsContainer: "#" + tArrow,
          responsive: {
            0: {
              items: 1,
              //fixedWidth: 300
            },
            768: {
              items: 2,
              //fixedWidth: false
            },
            992: {
              items: 3
            },
            1200: {
              items: 4
            }
          }
        });
      }
    }
  },
  sliderGallery: function(){
    if($(".inner-gallery-event").length){
      $('.popup-gallery-lead').magnificPopup({
        delegate: 'a',
        type: 'image',
        tLoading: 'Cargando imagen #%curr%...',
        mainClass: 'mfp-img-mobile',
        gallery: {
          enabled: true,
          navigateByImgClick: true,
          preload: [0,1] // Will preload 0 - before current, and 1 after the current image
        },
        image: {
          tError: '',
          titleSrc: function(item) {
            return item.el.attr('title');
          }
        }
      });
    }
  },
  hourReserv: function(){
    if($(".block-calendar-reserv").length){

       $('#datepickerMent').datepicker({
         language: "es",
         todayHighlight: true
       });

      if($('.footer-calendar-m').length){
        $(".hour-select").customSelect();
      }
      $(".event-resv").click(function(){
         var eventR = $(this);
         eventR.hide();
         eventR.parent("li").find(".resv-btn").show();
      });
    }
  },
  socialTeacher: function(){
    $(".up-social").click(function(){
      if($(this).parent(".downActive").length){
        $(this).parent(".social-teacher").removeClass("downActive");
      }else{
        $(this).parent(".social-teacher").addClass("downActive");  
      }
    });
  },
  icoWhats: function(){
     if($("#block-whats").length){
      var navigationContainer = $('#block-whats'),
      mainNavigation = navigationContainer.find('#cd-main-whats .block-nav-m');
      $('.cd-whats-trigger').on('click',function(e){
        e.preventDefault();
        $(this).toggleClass('menu-is-open');
        mainNavigation.off('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend').toggleClass('is-visible');
      });
    }
  },
  sliderFoundation: function(){
    $('.slider-primary').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: '.slider-secondary'
    });
    $('.slider-secondary').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      asNavFor: '.slider-primary',
      dots: true,
      centerMode: true,
      focusOnSelect: true,
      dots: false,
      arrows: false
    });
  },
  sliderTestimony: function(){
    if($(".slider-testimony").length){
      $('.s-test').slick({
        dots: true,
        infinite: true,
        speed: 300,
        arrows: false,
        slidesToShow: 1,
        adaptiveHeight: true,
      });
    }
  },
  videoIframe: function(){
    $(".item-video").click(function(){
      var htmlVideo = $(this).find(".hidden-video").html();
      var linkSrc = $(this).data("video");
      $('#videoModal').modal('show');
      $("#course-video-content").html(htmlVideo);
      setTimeout(function(){
        $("#course-video-content").find("iframe").attr("src", linkSrc);
      }, 200);
    });
    $('#videoModal').on('hidden.bs.modal', function (event) {
      $("#course-video-content").find("iframe").attr('src', '');
    });
  },
  moreComment: function(){
    console.log('moreComment');
    var contentComment = $("#allComment");
    var loadingComment = '<div class="loading-comment"><span></span></div>';
    $(".link-comment").on("click", function(){
        var pageCount = $(this).data("page-count");
        var paginated = $(this).data("paginated");//Obteniendo el paginado inicial
        var publicationId = $(this).data("publication");
        contentComment.prepend(loadingComment);//Agregando loading
        $.ajax({
            url: "/service/comments-publication/" + publicationId,
            data: {'page': paginated},
            type: 'GET',
            dataType: "json",
            beforeSend: function (xhr){ },
            success : function(data) {
              if(data.success) {
                console.log({
                  'pageCount': parseInt(pageCount),
                  'current': data.page.current,
                  'next': data.page.next
                });
                if(data.page.current == parseInt(pageCount)) {
                    // ver comentarios disabled - limit
                    $(".link-comment").removeClass("link-locked");//Eliminar el bloqueo
                }
                $(".loading-comment").remove();//Eliminando loading
                contentComment.addClass("display-comment");//Para eliminar el degradado
                $(".link-comment").data('paginated', data.page.next);//para agregar el paginado, 2,3,4, etc
                htmlComments = '';
                $.each(data.data, function(index, value) {
                    htmlAverage = '';
                    for (var i = 1; i <= value.average; i++) {
                       htmlAverage += '<i class="fas fa-star"></i>';
                    }
                    if(value.average < 5) {
                      for (var i = value.average; i <= 5; i++) {
                        htmlAverage += '<i class="far fa-star color-disable-star"></i>';
                      }
                    }

                    stringComment = '';
                    if(value.comment && value.comment != 'null') {
                        stringComment = value.comment;
                    }

                    flag = '';
                    if(value.countryCode) {
                        flag = data.baseCountry + 'assets/images/country/' + value.countryCode + '.svg';
                        stringFlag = '<span style="background: url(' + flag + ') no-repeat;background-size: cover;background-position: center;"></span>';
                    }

                    htmlComments += '<div class="clear-fix list-answer">' +
                              '<div class="row">' +
                                '<div class="col-md-4">' +
                                  '<div class="clear-fix b-figure-ans">' +
                                    '<figure>' +
                                      '<i style="background: url(' + value.image.thumbnai + ') no-repeat;background-size: cover;background-position: center;"></i>' +
                                      stringFlag +
                                    '</figure>' +
                                    '<h4>' + value.user + '</h4>' +
                                    '<div class="start-calf">' +
                                      htmlAverage +
                                    '</div>' +
                                  '</div>' +
                                '</div>' +
                                '<div class="col-md-8">' +
                                  '<div class="clear-fix inf-ans-t">' +
                                    '<p>' + stringComment + '</p>' +
                                  '</div>' +
                                '</div>' +
                              '</div>' +
                            '</div>';
                });
                $('#allComment').append(htmlComments);
              }
            }
        });
    });
  },
  moreBlockAll: function(){
    $(".all-t-more .moreActive").on("click", function(){
      $(this).parent().find(".b-p").toggleClass("hide-desc");
      $(this).parent().find(".b-p1").slideToggle(0);
      if($(this).text() == "Ver más"){
        $(this).text("Ver menos");
      }
      else{
        $(this).text("Ver más");
      }
    });

    $(".t-more-n .moreActive").on("click", function(){
      $(this).parent().find(".b-p1").toggleClass("t-active");
      $(this).parent().find(".b-p1").slideToggle(0);
      if($(this).hasClass('t-active')){
        $(this).html('Ocultar resumen <i class="fas fa-chevron-right"></i>');
      }
      else{
        $(this).html('Ver resumen <i class="fas fa-chevron-right"></i>');
      }
    });
  },
  countDownNavNoti: function(){
    if($(".listTiempoNavNoti").length){
      $('[data-countdownnavnoti]').each(function () {
        var $this = $(this);
        var finalDate = $(this).data('countdownnavnoti');
        var timeZone = $(this).data('timezone');        
        var newFinalDateTZ = finalDate;
        if (moment && timeZone) {
          var momentDate = moment.tz(finalDate, timeZone);
          newFinalDateTZ = momentDate.toDate();
        }        
        
        $this.countdown(newFinalDateTZ, function (event) {
            $this = $(this).html(event.strftime(''
            + '<div><span class="datos-tiempo">%D</span><em>Días</em></div><span>:</span>'
            + '<div><span class="datos-tiempo">%H</span><em>Horas</em></div><span>:</span>'
            + '<div><span class="datos-tiempo">%M</span><em>Min</em></div><span>:</span>'
            + '<div><span class="datos-tiempo">%S</span><em>Seg</em></div>'
            ));
        });
      });
    }
  }
}
